import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { translate } from "react-i18next";
import PersonIcon from "@material-ui/icons/Person";
import LockIcon from "@material-ui/icons/Lock";

import { userActions } from "../_actions";

import "./LoginPage.css";
import { THEME } from "../_constants";

const styles = theme => ({
    textfieldRoot: {
        paddingLeft: 15,
        paddingRight: 15,
        "label + &": {
            marginTop: theme.spacing.unit * 3
        }
    },
    buttonRoot: {
        boxShadow: "none",
        fontSize: 16,
        backgroundColor: THEME.COLOR.GREEN,
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"'
        ].join(","),
        "&:hover": {
            backgroundColor: THEME.COLOR.GREEN_HOVER
        }
    }
});

class LoginForm extends React.Component {
    constructor(props) {
        super(props); // reset login status
        this.props.dispatch(userActions.logout());
        this.state = {
            email: "",
            password: "",
            submitted: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.keyPress = this.keyPress.bind(this);
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value
        });
    };

    handleSubmit(e) {
        e.preventDefault();
        this.setState({ submitted: true });
        const { email, password } = this.state;
        const { dispatch } = this.props;
        if (email && password) {
            dispatch(userActions.login(email, password));
        }
    }

    keyPress(e) {
        if (e.keyCode === 13) {
            this.handleSubmit(e);
        }
    }

    render() {
        const { t, classes } = this.props;
        const { email, password, submitted } = this.state;
        const self = this;

        function renderInput(
            valueToCheck,
            icon,
            placeholder,
            key,
            type,
            onKeyDown = null
        ) {
            let error = submitted && !valueToCheck ? true : false;
            let borderColor = error ? "red" : THEME.COLOR.GRAY;

            return (
                <div
                    style={{
                        width: 340,
                        borderRadius: 3,
                        border: `1px solid ${borderColor}`,
                        paddingLeft: 15,
                        marginTop: 15,
                        marginBottom: 15,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center"
                    }}
                >
                    {icon}
                    <TextField
                        className="textfield"
                        id={key}
                        type={type}
                        placeholder={placeholder}
                        margin="dense"
                        onChange={self.handleChange(key)}
                        error={error}
                        onKeyDown={onKeyDown}
                        InputProps={{
                            disableUnderline: true,
                            classes: {
                                root: classes.textfieldRoot
                            }
                        }}
                    />
                </div>
            );
        }

        return (
            <form
                name="form"
                noValidate
                autoComplete={"on"}
                onSubmit={self.handleSubmit}
            >
                <div className="group">
                    {renderInput(
                        email,
                        <PersonIcon />,
                        t("Email"),
                        "email",
                        "email"
                    )}
                    {renderInput(
                        password,
                        <LockIcon />,
                        t("Password"),
                        "password",
                        "password",
                        self.keyPress
                    )}
                </div>

                <div
                    className="group"
                    style={{ width: "100%", textAlign: "end" }}
                >
                    {t("ForgetPass")}
                </div>

                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        alignContent: "center",
                        justifyContent: "space-between"
                    }}
                >
                    <div />
                    <Button
                        variant="contained"
                        color="primary"
                        disableRipple
                        className={classNames(classes.buttonRoot)}
                        onClick={event => self.handleSubmit(event)}
                    >
                        {t("Login")}
                    </Button>
                </div>

                <br />
            </form>
        );
    }
}

LoginForm.propTypes = {
    classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
}

const connectedLoginForm = connect(mapStateToProps)(
    translate("translations")(LoginForm)
);

const styledLoginForm = withStyles(styles)(connectedLoginForm);

export { styledLoginForm as LoginForm };



// WEBPACK FOOTER //
// ./src/LoginPage/LoginForm.js